(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/chat-host-schedule-card/assets/javascripts/partials/chat-host-date-and-time.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/chat-host-schedule-card/assets/javascripts/partials/chat-host-date-and-time.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect;
const useInterval = svs.components.lbUtils.useInterval;
const Badge = svs.ui.ReactBadge;
const ChatHostDateAndTime = _ref => {
  let startTime = _ref.startTime,
    endTime = _ref.endTime;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  const startDateObj = useMemo(() => new Date(startTime), [startTime]);
  const intervalId = useInterval(() => {
    const duration = dateFns.intervalToDuration({
      start: new Date(),
      end: startDateObj
    });
    setTimer(duration);
  }, 1000, true);
  useEffect(() => {
    if ((timer === null || timer === void 0 ? void 0 : timer.minutes) === 0 && (timer === null || timer === void 0 ? void 0 : timer.seconds) === 0) {
      clearInterval(intervalId);
    }
  }, [timer, intervalId]);
  if (!timer) {
    return null;
  }
  return React.createElement("div", {
    className: "bingo-chat-host-schedule-card-information__game-date"
  }, (timer === null || timer === void 0 ? void 0 : timer.minutes) === 0 && (timer === null || timer === void 0 ? void 0 : timer.seconds) === 0 ? React.createElement("div", null, "Idag") : React.createElement("div", null, "Startar om"), React.createElement("div", {
    className: "bingo-chat-host-schedule-card-information__chat-host-time"
  }, "".concat(timer.minutes.toString().padStart(2, '0'), ":").concat(timer.seconds.toString().padStart(2, '0'))), (timer === null || timer === void 0 ? void 0 : timer.minutes) === 0 && (timer === null || timer === void 0 ? void 0 : timer.seconds) === 0 && React.createElement(Badge, {
    branding: "red"
  }, "LIVE"));
};
setGlobal('svs.bingo_react.components.chatHostScheduleCard.ChatHostDateAndTime', ChatHostDateAndTime);

 })(window);